// Zod DTOs for the `/v1/tabs` authoring surface (spec §3.3 `ResourceTab`
// model, §6.2). `sectionId` is a path param on create (`POST
// /v1/sections/:id/tabs`); `position` is server-managed (append order — no
// dedicated tab-reorder endpoint is specced, so no `reorder` DTO here).
import { z } from 'zod';
import { TabKind } from '../enums';

const tabKindEnumSchema = z.enum(Object.values(TabKind) as [TabKind, ...TabKind[]]);

const labelSchema = z.string().trim().min(1).max(80);

// ─── POST /v1/sections/:id/tabs ─────────────────────────────────────────────
// `label` is optional on create — "overridable display name" (spec §3.3);
// the service defaults it from `kind`'s human label when omitted.

export const resourceTabCreateRequestSchema = z.object({
  kind: tabKindEnumSchema,
  label: labelSchema.optional(),
  allowDownload: z.boolean().optional(),
});
export type ResourceTabCreateRequest = z.infer<typeof resourceTabCreateRequestSchema>;

// ─── PATCH /v1/tabs/:id ──────────────────────────────────────────────────────
// `kind` is deliberately excluded — changing a tab's kind after resources
// have been filed under it would silently reclassify them; delete + recreate
// instead.

export const resourceTabUpdateRequestSchema = z.object({
  label: labelSchema.optional(),
  allowDownload: z.boolean().optional(),
  isPublished: z.boolean().optional(),
});
export type ResourceTabUpdateRequest = z.infer<typeof resourceTabUpdateRequestSchema>;
